module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/device-list/device-list.component.css
// module id = ./src/app/device-list/device-list.component.css
// module chunks = main